import React, {useContext} from 'react';
import {
  Row, Col, Typography, Divider, Image, Card, Descriptions, Tag, Carousel, Button
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShoppingCartOutlined } from '@ant-design/icons';
import CAgregarCarrito from './CAgregarCarrito.js';
import { GlobalContext } from '../../../../context/globalContext.js';
import productoDestacadoImg from '../../../../assets/producto_destacado.png';

// Componentes por tipo
import {
  CDetalleArticuloSupermercado,
  CDetalleArticuloIndumentaria,
  CDetalleArticuloElectronica,
  CDetalleArticuloElectrodomestico,
  CDetalleArticuloMueble,
  CDetalleArticuloJuguete,
  CDetalleArticuloCosmetico
} from './detallesCategorias/CDetalleCategorias.js';

const { Title, Text, Paragraph } = Typography;

const CDetalleArticuloInicio = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const articulo = state?.articulo;
  const { categorias } = useContext(GlobalContext);

  if (!articulo || !articulo.articulo_empresa) {
    return (
      <div style={{ padding: '2rem' }}>
        <Title level={4} type="danger">Error</Title>
        <Text>No se pudo cargar la información del artículo.</Text>
      </div>
    );
  }

  const { articulo_empresa: aem, datos_sucursal: asu } = articulo;
  const imagenes = [aem.aem_imagen, aem.aem_imagen2, aem.aem_imagen3].filter(Boolean);

  const tieneDescuentoVigente = (asu) => {
    if (
      !asu ||
      !asu.asu_precio_con_descuento ||
      !asu.asu_fecha_d_descuento ||
      !asu.asu_fecha_h_descuento
    ) return false;

    const hoy = new Date();
    const desde = new Date(asu.asu_fecha_d_descuento);
    const hasta = new Date(asu.asu_fecha_h_descuento);

    return hoy >= desde && hoy <= hasta;
  };

  const renderDetallePorTipo = () => {
    switch (aem.aem_tipo_id) {
      case 1: return <CDetalleArticuloSupermercado detalle={aem.detalle} />;
      case 2: return <CDetalleArticuloIndumentaria detalle={aem.detalle} />;
      case 3: return <CDetalleArticuloElectronica detalle={aem.detalle} />;
      case 4: return <CDetalleArticuloElectrodomestico detalle={aem.detalle} />;
      case 5: return <CDetalleArticuloMueble detalle={aem.detalle} />;
      case 6: return <CDetalleArticuloJuguete detalle={aem.detalle} />;
      case 7: return <CDetalleArticuloCosmetico detalle={aem.detalle} />;
      default: return null;
    }
  };

  const getRutaCategoria = (categoriaId, categorias) => {
    const ruta = [];
    let actual = categorias.find(c => c.cat_id === categoriaId);
    while (actual) {
      ruta.unshift(actual.cat_nombre);
      actual = categorias.find(c => c.cat_id === actual.cat_padre_id);
    }
    return ruta;
  };


  const mostrarDescuento = tieneDescuentoVigente(asu);
  const porcDesc =
    asu?.asu_porc_descuento != null ? Number(asu.asu_porc_descuento) : null;
  const mostrarTachadoYBadge = mostrarDescuento && porcDesc != null && porcDesc > 0;

  const returnTo = state?.returnTo;

  return (
    <div>
      <Button
        type="default"
        onClick={() => {
          // Si viniste desde la lista, restauramos filtros/categoría.
          if (returnTo?.filters) {
            navigate('/home', { state: { returnTo } });
            return;
          }
          // Fallback: volver por historial.
          navigate(-1);
        }}
        style={{ marginBottom: '1rem' }}
      >
        ← Volver a la lista
      </Button>

      <Row gutter={[32, 32]}>
        {/* IMÁGENES */}
        <Col xs={24} md={12}>
          <Card>
            <div style={{ position: 'relative' }}>
              {asu != null && asu.asu_orden_relevancia != null && (
                <img
                  src={productoDestacadoImg}
                  alt=""
                  role="presentation"
                  style={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    zIndex: 3,
                    width: 'auto',
                    maxWidth: 'min(38%, 200px)',
                    maxHeight: 48,
                    height: 'auto',
                    objectFit: 'contain',
                    pointerEvents: 'none',
                  }}
                />
              )}
              <Carousel autoplay dotPosition="bottom">
                {imagenes.map((img, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 550
                    }}
                  >
                    <Image
                      src={img}
                      alt={`Imagen ${idx + 1}`}
                      style={{ maxHeight: 500, maxWidth: '100%', objectFit: 'contain' }}
                      preview
                    />
                  </div>
                ))}
              </Carousel>
            </div>
          </Card>
        </Col>

        {/* INFO PRINCIPAL */}
        <Col xs={24} md={12}>
          {/* Ruta de categoría estilo breadcrumb */}
          {categorias && (
            <div>
              {getRutaCategoria(aem.aem_categoria_id, categorias).map((nombre, idx, arr) => (
                <span key={idx} style={{ color: '#1890ff', cursor: 'default' }}>
                  {nombre}
                  {idx < arr.length - 1 && <span style={{ margin: '0 4px' }}>›</span>}
                </span>
              ))}
            </div>
          )}
          <Title level={3} style={{ marginBottom: 0 }}>{aem.aem_nombre}</Title>
          <Text type="secondary">SKU: {aem.aem_sku}</Text>

          <div style={{ margin: '1.2rem 0' }}>
            {mostrarTachadoYBadge ? (
              <>
                <Text strong style={{ fontSize: 26, color: '#52c41a' }}>
                  ${asu.asu_precio_con_descuento.toLocaleString()}
                </Text>
                <div>
                  <Text delete style={{ marginRight: 8, fontSize: 14, color: '#999' }}>
                    ${asu.asu_precioventa.toLocaleString()}
                  </Text>
                  <Text type="success">-{porcDesc}% OFF</Text>
                </div>
              </>
            ) : (
              <Text strong style={{ fontSize: 26, color: '#52c41a' }}>
                $
                {mostrarDescuento && asu?.asu_precio_con_descuento != null
                  ? asu.asu_precio_con_descuento.toLocaleString()
                  : (asu?.asu_precioventa?.toLocaleString() ?? 'Precio no disponible')}
              </Text>
            )}
          </div>

          {asu?.asu_stock && (
            <Text style={{ display: 'block', marginBottom: 12 }}>
              <b>Stock disponible:</b> {asu.asu_stock} unidades
            </Text>
          )}

          <CAgregarCarrito
            articulo={articulo}
            onAgregar={(articulo, cantidad) => {
              console.log('Agregar al carrito:', articulo, 'Cantidad:', cantidad);
            }}
          />

          {renderDetallePorTipo()}
        </Col>
      </Row>

      {/* DATOS GENERALES */}
      <Row gutter={[32, 32]} style={{ marginTop: '2rem' }}>
        <Col xs={24}>
          <Paragraph strong>Datos generales del artículo</Paragraph>
          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="Marca" span={2}>{aem.aem_marca}</Descriptions.Item>
            <Descriptions.Item label="Descripción corta" span={2}>{aem.aem_descripcion_corta}</Descriptions.Item>
            <Descriptions.Item label="Descripción larga" span={2}>{aem.aem_descripcion_larga}</Descriptions.Item>
            <Descriptions.Item label="Etiquetas" span={2}>
              {aem.aem_tags
                ? aem.aem_tags.split(',').map((tag, i) => <Tag key={i}>{tag.trim()}</Tag>)
                : <Text type="secondary">Sin tags</Text>}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </div>
  );
};

export default CDetalleArticuloInicio;